module.exports = __webpack_public_path__ + "img/loading.d13d6d60.gif";